import { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { fetchUser } from '../reducer/userActions';

class WithdrawalContent extends Component {
    state = {
        coin: this.props.method || "",
        selectedWallet: "",
        activeRequest: false,
        submitted: false,

        userInfo: [],
        loading: false,
        network: false,
        error: "",

        walletAddress: "",
        amount: 0,
        withdrawPin: 0,


        accountNumber: 0,
        accountName: "",
        bankName: "",

    }


    componentDidUpdate(prevProps, prevState) {
        if (prevProps.user !== this.props.user) {
            this.setState({ userInfo: this.props.user });
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if (user) {
            this.setState({ userInfo: user });
        }
    }







    handleInputChange = (event) => {
        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }
    handleRadio = (type) => {
        this.setState({ selectedWallet: type });
    };


    handlePreSubmit = (e) => {
        e.preventDefault()
        this.setState({ activeRequest: true });
    }



    handleSubmit = async (e) => {
        e.preventDefault()

        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        const dataToSend = {
            walletAddress: this.state.walletAddress,
            amount: this.state.amount,
            withdrawPin: this.state.withdrawPin,
            method: this.state.coin
        };

        try {
            const response = await axios.post("https://teslasafebroker.com/api/withdraw/crypto", dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({ userInfo: response.data.user, loading: false, submitted: true });
                this.props.fetchUser()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }
            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response && error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message

                const errorMessage =
                    error.response.data?.message || // if backend sends { message: "..." }
                    error.response.statusText ||    // fallback to status text like "Unauthorized"
                    "Authentication error. Redirecting to login...";

                // Show the exact error to user
                this.setState({ error: errorMessage });
                setTimeout(() => {
                    window.location.href = "/login";
                }, 5000);
            } else {
                console.error("Error fetching user data:", error);
                // Handle other HTTP errors (e.g., 400, 500)
                let errorMessage = "An unexpected error occurred.";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                // Set error message in state
                this.setState({ error: errorMessage });

                // Clear error message after 10 seconds
                setTimeout(() => {
                    this.setState({ error: "" });
                }, 10000);
            }
        }
    }







    handleSubmitCard = async (e) => {
        e.preventDefault()

        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        const dataToSend = {
            accountNumber: this.state.accountNumber,
            accountName: this.state.accountName,
            bankName: this.state.bankName,
            amount: this.state.amount,
            withdrawPin: this.state.withdrawPin,
            method: this.state.coin
        };

        try {
            const response = await axios.post("https://teslasafebroker.com/api/withdraw/card", dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({ userInfo: response.data.user, loading: false, submitted: true });
                this.props.fetchUser()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }
            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response && error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message

                const errorMessage =
                    error.response.data?.message || // if backend sends { message: "..." }
                    error.response.statusText ||    // fallback to status text like "Unauthorized"
                    "Authentication error. Redirecting to login...";

                // Show the exact error to user
                this.setState({ error: errorMessage });
                setTimeout(() => {
                    window.location.href = "/login";
                }, 5000);
            } else {
                console.error("Error fetching user data:", error);
                // Handle other HTTP errors (e.g., 400, 500)
                let errorMessage = "An unexpected error occurred.";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                // Set error message in state
                this.setState({ error: errorMessage });

                // Clear error message after 10 seconds
                setTimeout(() => {
                    this.setState({ error: "" });
                }, 10000);
            }
        }
    }






    render() {


        const { method } = this.props
        const { activeRequest, walletAddress, amount, withdrawPin, submitted, error, accountNumber, accountName, bankName, loading } = this.state



        return (
            <div className="payment_cover">
                {method === "bank_card" || method === "online_transfer" ?
                    <>
                        <form onSubmit={this.handlePreSubmit}>
                            <label>Account number</label><br />
                            <input type="number" name="accountNumber" id="accountNumber" value={accountNumber} onChange={this.handleInputChange} /><br /><br />

                            <label>Accountholder name</label><br />
                            <input type="text" name="accountName" id="accountName" value={accountName} onChange={this.handleInputChange} /><br /><br />

                            {/*<div className="input">
                            <div className="half">
                                <label>Bank Name</label><br />
                                <input type="" name="" id="" value="" onChange={this.handleInputChange} />
                            </div>
                             <div className="half">
                                <label>CVV / CVC Code</label><br />
                                <input type="" name="" id="" value="" onChange={this.handleInputChange} />
                            </div>
                        </div><br /><br />*/}

                            <label>Bank Name</label><br />
                            <input type="text" name="bankName" id="bankName" value={bankName} onChange={this.handleInputChange} /><br /><br />



                            <label>Amount (USD)</label><br />
                            <input type="number" name="amount" id="amount" value={amount} onChange={this.handleInputChange} /><br /><br />



                            {!activeRequest &&
                                <div className="button">
                                    <button>Continue</button>
                                </div>
                            }
                        </form>
                        <form onSubmit={this.handleSubmitCard}>

                            {activeRequest &&
                                <>
                                    {!submitted ?
                                        <>
                                            <label>Withdrawal Pin</label><br />
                                            <input type="number" name="withdrawPin" id="withdrawPin" value={withdrawPin} onChange={this.handleInputChange} required /><br /><br />
                                            <p>Contact support to get your withdrawal pin</p>

                                            <div className="button">
                                                <button className="black" type="submit" disabled={loading}>Place Withdrawal</button>
                                            </div>
                                            <p style={{ color: "red" }}>{error}</p>

                                        </>
                                        :
                                        <>
                                            <p>
                                                Your withdrawal is being processed. The funds will be transferred to your account shortly.
                                            </p>
                                            <div className="button" type="button">
                                                <Link to="/dashboard"><button>Go to Dashboard</button></Link>
                                            </div>


                                        </>
                                    }



                                </>
                            }

                        </form>

                    </>
                    :

                    <>
                        <form onSubmit={this.handlePreSubmit}>
                            <label>Payment method</label><br />
                            <select name="coin" id='coin' value={this.state.coin} onChange={this.handleInputChange} required disabled>
                                <option value="bitcoin">Bitcoin (BTC)</option>
                                <option value="ethereum">Ethereum (ETH)</option>
                                <option value="bnb">BNB </option>
                                <option value="tether_trc">Tether (USDT TRC20)</option>
                            </select><br /><br />



                            <label>To External Wallet</label><br />
                            <input type="text" name="walletAddress" id="walletAddress" value={walletAddress} onChange={this.handleInputChange} required disabled={activeRequest} /><br /><br />


                            <label>Amount (USDT)</label><br />
                            <input type="number" name="amount" id="amount" value={amount} onChange={this.handleInputChange} required disabled={activeRequest} /><br /><br />

                            {!activeRequest &&
                                <div className="button">
                                    <button>Continue</button>
                                </div>
                            }
                        </form>
                        <form onSubmit={this.handleSubmit}>

                            {activeRequest &&
                                <>
                                    {!submitted ?
                                        <>
                                            <label>Withdrawal Pin</label><br />
                                            <input type="number" name="withdrawPin" id="withdrawPin" value={withdrawPin} onChange={this.handleInputChange} required /><br /><br />
                                            <p>Contact support to get your withdrawal pin</p>

                                            <div className="button">
                                                <button className="black" type="submit" disabled={loading}>Place Withdrawal</button>
                                            </div>
                                            <p style={{ color: "red" }}>{error}</p>

                                        </>
                                        :
                                        <>
                                            <p>
                                                Your withdrawal is being processed. The funds will be transferred to your account shortly.
                                            </p>
                                            <div className="button" type="button">
                                                <Link to="/dashboard"><button>Go to Dashboard</button></Link>
                                            </div>


                                        </>
                                    }



                                </>
                            }

                        </form>
                    </>
                }



            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
});




export default connect(mapStateToProps, { fetchUser })(WithdrawalContent) 